import React from "react";
import { Link } from "react-router-dom";
import { TopClickedCall } from "../../../types/email-tracking.types";

interface TopClickedCallsProps {
  data: TopClickedCall[];
}

export const TopClickedCalls: React.FC<TopClickedCallsProps> = ({ data }) => {
  if (!data.length) {
    return (
      <div className="bg-white rounded-lg border border-neutral-200 p-4">
        <h4 className="text-sm font-semibold text-neutral-900 mb-3">
          Top klikane nabory
        </h4>
        <div className="text-neutral-500 text-sm">Brak danych</div>
      </div>
    );
  }

  return (
    <div
      className="bg-white rounded-lg border border-neutral-200 p-4"
      data-testid="ranking-top-clicked-calls"
      role="region"
      aria-label="Top klikane nabory"
    >
      <h4 className="text-sm font-semibold text-neutral-900 mb-3">
        Top klikane nabory
      </h4>

      <div className="space-y-2">
        {data.map((item, index) => (
          <div
            key={item.callId}
            className="flex items-center gap-3 py-2 border-b border-neutral-50 last:border-0"
            data-testid={`top-call-item-${index}`}
          >
            {/* Rank badge */}
            <div
              className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium ${
                index === 0
                  ? "bg-yellow-100 text-yellow-700"
                  : index === 1
                    ? "bg-neutral-100 text-neutral-600"
                    : index === 2
                      ? "bg-amber-100 text-amber-700"
                      : "bg-neutral-50 text-neutral-500"
              }`}
            >
              {index + 1}
            </div>

            {/* Title and link */}
            <div className="flex-1 min-w-0">
              <Link
                to={`/grants/calls/${item.callId}`}
                className="text-sm text-primary-600 hover:text-primary-700 hover:underline truncate block"
                title={item.title}
              >
                {item.title}
              </Link>
            </div>

            {/* Count */}
            <div className="text-sm font-medium text-neutral-900 whitespace-nowrap">
              {item.count.toLocaleString()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopClickedCalls;
